import { render, staticRenderFns } from "./AppProfileAsideMenu.vue?vue&type=template&id=bc711426&scoped=true&"
import script from "./AppProfileAsideMenu.vue?vue&type=script&lang=js&"
export * from "./AppProfileAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppProfileAsideMenu.vue?vue&type=style&index=0&id=bc711426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc711426",
  null
  
)

export default component.exports